// extracted by mini-css-extract-plugin
export default {"clickable":"TableItem_clickable__9kA1j","level-item":"TableItem_level-item__MXRth","alignCenter":"TableItem_alignCenter__J-omq","disabled":"TableItem_disabled__3GtmJ"};